export default {"src":"/_next/static/media/shopping_basket.022c632c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};